import Script from "next/script"
import Block from "@/components/wrappers/block"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./active-campaign.module.css"
import classNames from "classnames"

export default function ActiveCampaign({ block }) {
  const { formId, blockGap, bgColor, heading, text } = block.attrs
  const scriptSrc = `https://naturskyddsforeningen.activehosted.com/f/embed.php?id=${formId}`

  if (formId < 1) {
    return null
  }

  return (
    <Block
      block={block}
      gap={blockGap}
      innerWrapper={true}
      width="bleed"
      className={classNames(styles.wrapper, "bg-color-" + bgColor)}>
      <BlockHeader heading={heading} text={text} className="max-w-1xl" />
      <Script src={scriptSrc} async />
      <div className={"_form_" + formId} />
    </Block>
  )
}
